import { HttpClient, HttpHandler, HttpRequest, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, } from 'rxjs';
import { Injectable } from '@angular/core';

type HttpObserve = 'body' | 'events' | 'response';

export abstract class HttpParamsBuilder {
  abstract fromClone(source: HttpParams): HttpParams;
  abstract fromObject(source: { [param: string]: unknown | unknown[] }): HttpParams;
}

@Injectable()
export class CorrectedHttpClient extends HttpClient {

  constructor(handler: HttpHandler,
    protected paramsBuilder: HttpParamsBuilder) {
    super(handler);
  }

  request(first: string | HttpRequest<any>, url?: string, options: {
    body?: any,
    headers?: HttpHeaders | { [header: string]: string | string[] },
    observe?: HttpObserve,
    params?: HttpParams | { [param: string]: unknown | unknown[] },
    reportProgress?: boolean,
    responseType?: 'arraybuffer' | 'blob' | 'json' | 'text',
    withCredentials?: boolean,
  } = {}): Observable<any> {

    // Se o primeiro parâmetro é já um HttpRequest é porque já está tudo tratado, é só encaminhar
    if (first instanceof HttpRequest) {
      const clone = first.clone({ headers: first.headers.set("X-Requested-With", "XMLHttpRequest") });
      return super.request(clone);
    }
    else {
      // Se o primeiro parâmetro não é um HttpRequest então temos que tratar dos parâmetros e fazer seguir
      //options ??= {};

      if (options.params) {
        if (options.params instanceof HttpParams) {
          options.params = this.paramsBuilder.fromClone(options.params);
        } else {
          options.params = this.paramsBuilder.fromObject(options.params);
        }
      }
      // Isto é necessário para que o .NET entende isto como chamadas de API e envie
      // 401 + location em vez de 302 nas chamadas unauthorized
      if (!options.headers)
        options.headers = { "X-Requested-With": "XMLHttpRequest" };
      else if (options.headers instanceof HttpHeaders)
        options.headers = options.headers.set("X-Requested-With", "XMLHttpRequest");
      else
        options.headers["X-Requested-With"] = "XMLHttpRequest";

      return super.request(first, url, options as any);
    }
  }
}
